import { Component, signal, OnInit, AfterViewInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Theme } from './services/theme';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.scss']
})
export class App implements OnInit, AfterViewInit {
  protected readonly title = signal('bella-studio');
  
  constructor(
    private theme: Theme,
  ) {}

  ngOnInit(): void {
    this.theme.initializeTheme();
  }

  ngAfterViewInit(): void {
    document.fonts
      .load('24px "Material Symbols Outlined"')
      .then(() => {
        document.body.classList.add('app-ready');
      });
  }
}
